(function ($) {
  window.isHerzenssache = true;
})(window.jQuery);
